import './SearchResults.css';
import React from 'react';
import SearchResultsList from './SearchResultsList';
const SearchResults = _ref => {
  let {
    sitecoreContext,
    analytics,
    params,
    defaultTypeValues,
    lbNoResults,
    activeListingItemId,
    lbResultsFor,
    getActivePopupOnMap,
    activeTopPicks,
    toggleActiveTopPicks,
    hits,
    query,
    mainHitsPerPage
  } = _ref;
  const hasResults = query && hits.length !== 0;
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  return /*#__PURE__*/React.createElement("div", {
    className: `search-results ${query ? 'visible' : ' '} imfilters-padding ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, query && /*#__PURE__*/React.createElement(React.Fragment, null, hits && hits.length ? /*#__PURE__*/React.createElement("div", {
    className: "results-amount"
  }, /*#__PURE__*/React.createElement("b", null, `${hits.length} `), lbResultsFor.value, /*#__PURE__*/React.createElement("b", null, ` "${query}"`)) : /*#__PURE__*/React.createElement("div", {
    className: "results-amount"
  }, lbNoResults.value)), query && hasResults && /*#__PURE__*/React.createElement(SearchResultsList, {
    params: params,
    rtl: rtl,
    defaultTypeValues: defaultTypeValues,
    activeListingItemId: activeListingItemId,
    getActivePopupOnMap: getActivePopupOnMap,
    activeTopPicks: activeTopPicks,
    toggleActiveTopPicks: toggleActiveTopPicks,
    hits: hits,
    mainHitsPerPage: mainHitsPerPage,
    query: query,
    analytics: analytics
  }));
};
export default SearchResults;
const commonStyles = "c1u2pec0";
const ltrStyles = "l1s6emgl";
const rtlStyles = "rchgxkq";